export const main = (filters) => [











  {text: '', value: 'actions', width: 100},
  { text: 'Mã', align: 'start', value: 'code', width: '5rem',  
      filter: value => {
                  if ( !filters.find(x=>x.name === 'id')?.value) return true
                  return value == filters.find(x=>x.name === 'id')?.value
      }
  },
  { text: 'Tên BC', align: 'start', value: 'name', width: '7rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'phoneNumber')?.value) return true
        return value.includes(filters.find(x=>x.name === 'phoneNumber')?.value)
      }
  },
  { text: 'Phòng/Store', align: 'start', value: 'departmentName', width: '10rem',  
      filter: value => true
  },

  { text: 'Danh mục', align: 'start', value: 'imageReportCategoryName', width: '10rem',  
      filter: value => true
  },
  
  { text: 'Hình ảnh', align: 'start', value: 'attachmentUrl', width: '10rem',  
      filter: value => true
  },

  { text: 'Trạng thái', align: 'start', value: 'status', width: '10rem',  
      filter: value => true
  },

  { text: 'Mô tả', align: 'start', value: 'description',
      filter: value => true
  },
  
  { text: 'Người tạo', align: 'start', value: 'createdByName',
      filter: value => true
  },
  
  { text: 'Người tạo (mã NS)', align: 'start', value: 'createdByCode',
      filter: value => true
  },
  
  { text: 'Thời gian', align: 'start', value: 'createdAt',
      filter: value => true
  },

// CheckInIp
// CheckInPlace
// CheckOutIp
// CheckOutPlace
// CreatedAt
// Review
// CheckInTime
// CheckOutTime
// CheckInStoreCode
// CheckOutStoreCode
// CheckInAddress
// CheckInLong
// CheckInLat
// CheckOutAddress
// CheckOutLong
// CheckOutLat

]